module.exports = __webpack_public_path__ + "img/PAS.689e45b4.png";